import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'RestoreMyWord - Biblical Stories and Resources for Gen Z',
  description = 'Empowering Gen Zers ages 10-20 to become mighty men and women of faith through Bible-based stories, audio teachings, and video resources. Free biblical resources for every generation.',
  keywords = 'Bible stories, Gen Z faith, Christian resources, biblical teachings, audio Bible, video Bible stories, youth ministry, Christian Gen Z, faith resources, free Bible content',
  image = 'https://customer-assets.emergentagent.com/job_faith-library-22/artifacts/dz85xhzt_Screenshot_2026-06-25-00-14-57-82_f69139cffc4d135a71392e13634f144a.jpg',
  url = 'https://restoremyword.net/',
  type = 'website'
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "RestoreMyWord",
    "alternateName": "Restore My Word",
    "url": "https://restoremyword.net/",
    "logo": image,
    "description": description,
    "sameAs": [
      "https://www.facebook.com/share/1Lfn9mxycs/",
      "https://youtube.com/@darelldyal",
      "https://www.tiktok.com/@darelldyal0"
    ]
  };

  const websiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "RestoreMyWord",
    "url": "https://restoremyword.net/",
    "description": description,
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://restoremyword.net/library/story?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="RestoreMyWord" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteData)}
      </script>
    </Helmet>
  );
};

export default SEO;
